import React, { useState } from "react";
import StepAcademic from "./StepAcademic";
import StepGoals from "./StepGoals";
import StepContact from "./StepContact";
import StepProgress from "./StepProgress";


export default function EligibilityFlow() {
  const [step, setStep] = useState(1);
  const handleEligibilitySuccess = () => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-759404552/q3tmCLm87JYcEIiwjuoC",
      });
    }
  };

  // Unified form state (shared across all steps)
  const [formData, setFormData] = useState({
    
    // STEP 1 – Academic
    qualification: "",
    field: "",
    graduationYear: "",
    score: "",
    backlogs: "No",

    // STEP 2 – Goals
    preferredCountry: "",
    targetLevel: "",
    intake: "",
    englishTest: "",

    // STEP 3 – Contact
    email: "",
    phone: "",
  });

  // Merge updates from child steps
  const updateFormData = (updatedFields) => {
    setFormData((prev) => ({
      ...prev,
      ...updatedFields,
    }));
  };

  return (
    <section className="min-h-screen bg-gradient-to-br from-[#F9FAFB] to-[#EEF1F6] py-16">
      <div className="max-w-2xl mx-auto px-4">
        <StepProgress step={step} />
        {/* STEP 1 */}
        {step === 1 && (
          <StepAcademic
            data={formData}
            onUpdate={updateFormData}
            onNext={() => setStep(2)}
          />
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <StepGoals
            data={formData}
            onUpdate={updateFormData}
            onNext={() => setStep(3)}
            onBack={() => setStep(1)}
          />
        )}

        {/* STEP 3 */}
        {step === 3 && (
          <StepContact
            data={formData}
            onUpdate={updateFormData}
            onBack={() => setStep(2)}
            onSuccess={handleEligibilitySuccess}
          />
        )}
      </div>
    </section>
  );
}
